import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      visibility: "hidden",
      d: "M5 32C5 17.64 16.674 6 31.076 6c14.4 0 26.076 11.64 26.076 26S45.477 58 31.076 58C16.674 58 5 46.36 5 32z",
      fill: "#86bc4d"
    }, null, -1),
    _createElementVNode("path", {
      d: "M31.5 10.5l-14 43m14-45l-23 17m9 27l-9-27m45-9l-6 24m-15-32l15 31",
      stroke: "#1e3951",
      "stroke-width": "4",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M55.5 16.5l-5 26m-21-34l-14 43m13-44l-21 16m22-15l17 34m-32 10l-8-27",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2 25c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6zM24 8c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6zM48 16c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6zM42 41c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6zM10 51c0-3.314 2.686-6 6-6s6 2.686 6 6-2.686 6-6 6-6-2.686-6-6z",
      stroke: "#fff",
      "stroke-width": "2",
      fill: "#55acba"
    }, null, -1)
  ])))
}
export default { render: render }